export default "__VITE_ASSET__BkAEqE$6__"